import { FieldValidator, useField } from "formik"
import React, { useCallback } from "react"

import Input, { InputProps } from "."

type FormikInputProps = InputProps & {
  name: string
  isValidating?: boolean
  validate?: FieldValidator
  prefix?: () => React.JSX.Element
  "data-testid"?: string
}

const FormikInput = ({
  name,
  validate,
  isValidating = false,
  prefix,
  className,
  ...props
}: FormikInputProps) => {
  const [field, meta, helpers] = useField({ name, validate })
  const setFieldValue = useCallback(
    (value: string) => {
      helpers.setValue(value)
      helpers.setTouched(true)
    },
    [helpers],
  )

  return (
    <Input
      id={name}
      invalid={!isValidating && meta.touched && !!meta.error}
      setInputValue={setFieldValue}
      prefix={prefix}
      className={className}
      {...field}
      data-testid={props["data-testid"]}
    />
  )
}

export default FormikInput
